import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CheckCircle2, ShieldCheck, Search, Award, Calendar, Building, UserCheck, Download, ExternalLink, FileText, Trophy, Share2, Copy, Check } from 'lucide-react';
import { getPointsForMember, getRoleForRank, getRankedMembers, getWhatsAppShareUrl } from '../../services/referralService';

export const VERIFIED_MEMBERS = [
  {
    refId: 'ANRD/AB/2026/001',
    name: 'Mrs. M. Geetha, M.Phil',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in English',
    institution: 'A.V.C. College (Autonomous), Mannampandal',
    location: 'Mayiladuthurai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 21, 2026',
    driveUrl: 'https://drive.google.com/file/d/1HTVh3Sd2VbisjpjxphEHAw-oJsnxmxm6/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/002',
    name: 'Dr. D. Lourdhu Mary, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor & Research Supervisor (Department of English)',
    institution: 'Karpagam Academy of Higher Education (Deemed to be University)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 21, 2026',
    driveUrl: 'https://drive.google.com/file/d/198o7DY2Pt_7Yd81z_d0EArzSc-9iIcD-/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/003',
    name: 'Mr. Brahma Naidu Chavali',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Senior Faculty in English',
    institution: 'School Education Department',
    location: 'Andhra Pradesh',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 22, 2026',
    driveUrl: 'https://drive.google.com/file/d/1PPzY0WqcJ45bL-T7KNvJ5JxcWvR9TpIB/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/004',
    name: 'Dr. R. Kumara Balaji, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor (SS) of English (Department of Languages)',
    institution: 'Periyar Maniammai Institute of Science & Technology (Deemed to be University)',
    location: 'Thanjavur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 22, 2026',
    driveUrl: 'https://drive.google.com/file/d/10idl8V3eHFqISbzlt_aQeDrTkhxvb_1L/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/005',
    name: 'Dr. M. Leena Chandrika, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in English',
    institution: 'Sri Ramakrishna Engineering College',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 22, 2026',
    driveUrl: 'https://drive.google.com/file/d/1uVC8yOfYopSztwwaeqVQaV-iRO2Ta8Pz/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/006',
    name: 'Dr. A. Balasubramanian, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in Management Studies (MBA)',
    institution: 'Nehru Institute of Information Technology & Management',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 22, 2026',
    driveUrl: 'https://drive.google.com/file/d/10UUav3fNSXRIn4dZALE2tjqzwg7QUMYV/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/007',
    name: 'Ms. B. Malini, M.Phil',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in English',
    institution: 'Sri Kaliswari College (Autonomous)',
    location: 'Sivakasi, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 23, 2026',
    driveUrl: 'https://drive.google.com/file/d/1XeeuWpT9ACLo-cGso1Kjykg1mtfVkQls/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/008',
    name: 'Dr. T. Ezhilarasi, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor (Department of Management Studies)',
    institution: 'Jai Shriram Engineering College (Autonomous)',
    location: 'Tirupur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 23, 2026',
    driveUrl: 'https://drive.google.com/file/d/1FJ7jpBELPgaE7FNxCIKMxQDzC-m8Kgne/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/009',
    name: 'Prof. M. Nallakurumban, M.Phil',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor of English',
    institution: 'Arul Anandar College',
    location: 'Karumathur, Madurai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 25, 2026',
    driveUrl: 'https://drive.google.com/file/d/1_HybefFIV3_z3MFEQvY565foDKsMFOAN/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/010',
    name: 'Prof. E. Annal Sheeba Rani',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor (Artificial Intelligence & Data Science)',
    institution: 'JCT College of Engineering and Technology',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 25, 2026',
    driveUrl: 'https://drive.google.com/file/d/1yACUiSieTxaYV8UKABJTISzm7REyeSv2/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/011',
    name: 'Dr. Mydhili S.K., Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Professor (Electronics & Communication Engineering)',
    institution: 'United Institute of Technology',
    location: 'Periyanaickenpalayam, Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 26, 2026',
    driveUrl: 'https://drive.google.com/file/d/1KdslfJpUB_XUbnV8t_x46eHmceaX2YXH/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/012',
    name: 'Prof. K. Muthukumar',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Management Studies (MBA)',
    institution: 'Jai Shriram Engineering College',
    location: 'Avinashipalayam, Tirupur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 26, 2026',
    driveUrl: 'https://drive.google.com/file/d/1ncNNMeFMrzYMhF3Axzq4wQR8FLcAlgll/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/013',
    name: 'Prof. M. Praveenkumar',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in Management Studies (MBA)',
    institution: 'Jai Shriram Engineering College',
    location: 'Avinashipalayam, Tirupur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 26, 2026',
    driveUrl: 'https://drive.google.com/file/d/1KXHDzDgUaVv_4U5l5a_f76BzmK2Ub90Q/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/014',
    name: 'Prof. T. Udhayakumar',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Computer Science & Engineering (CSE)',
    institution: 'Department of Computer Science & Engineering',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 26, 2026',
    driveUrl: 'https://drive.google.com/file/d/1Mu-KzmZrHb76Ds8dO6NbmHtmv6WICtmx/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/015',
    name: 'Prof. S. Jayaprakash',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Computer Science & Engineering (CSE)',
    institution: 'Hindusthan Institute of Technology',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 26, 2026',
    driveUrl: 'https://drive.google.com/file/d/1JJVX1Tm1LH9Sf1kQ1_MzzI8wnBs73LZT/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/016',
    name: 'Mr. Debabrata Roy',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Faculty & Researcher in English (School of Languages)',
    institution: 'School of Languages & Research',
    location: 'Haldia, East Midnapore, West Bengal',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 26, 2026',
    driveUrl: 'https://drive.google.com/file/d/1jmJvlvZyrl2OROdmktWb4_xhXxdUVwsd/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/017',
    name: 'Dr. N. Maryanna Harris, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor of English',
    institution: 'Christ Arts and Science College',
    location: 'Kilachery, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 27, 2026',
    driveUrl: 'https://drive.google.com/file/d/1wJVsoCFCR4b7f4YBDyU7uWqr64XwwqCD/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/018',
    name: 'Dr. K. Vinoth, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor (Artificial Intelligence & Machine Learning)',
    institution: 'SRM Institute of Science and Technology (SRMIST)',
    location: 'Kattankulathur, Chennai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 27, 2026',
    driveUrl: 'https://drive.google.com/file/d/1xPApeG2OT6uyVlZrU4iyzIhsVrtBuWBv/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/019',
    name: 'Dr. M. S. Parkavi, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor of English',
    institution: 'Government Arts and Science College',
    location: 'Aranthangi, Pudukkottai District, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 27, 2026',
    driveUrl: 'https://drive.google.com/file/d/1iyNlP66uQYE2JnfQMWx0c9TbDHPcRVcL/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/020',
    name: 'Prof. A. Dinesh Kumar',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor (Artificial Intelligence & Data Science)',
    institution: 'Sri Ranganathar Institute of Engineering and Technology',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1drB2YosSTXdCHpnBR-x2-ZF0AdmAKVdB/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/021',
    name: 'J. Samuel Santhosh',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor of English',
    institution: 'Kongunadu Arts and Science College',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1u2yXEY7l9Gdjxh9kfSJSHqtl7gYhFiFm/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/022',
    name: 'Dr. B. Balamayurathan, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Associate Professor of English',
    institution: 'Sri Ramakrishna College of Arts & Science (Autonomous)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1Fc-rM9T0gLslFcyllgJeKKzRwgbn5XEp/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/023',
    name: 'Mrs. S. Subitsha',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in English',
    institution: 'Sri Ramakrishna College of Arts & Science',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1nxBTCTSG9et-hP11zzYz4TnaTSyWePlg/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/024',
    name: 'Mr. M. Siva Ram Sanker',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Research Scholar in English (M.Phil)',
    institution: 'SNR College of Arts and Science',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1LtEkEnUhcqGXRZ2E6qo1KWDyG6KZXMlS/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/025',
    name: 'Ms. Malliga N',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Research Scholar in English (Ph.D)',
    institution: 'Sri Ramakrishna College of Arts and Science (Autonomous)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1aK9imbpsoWZ1vclWyPpOEX4utzzxXyLf/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/026',
    name: 'Mrs. S. Ambigabathi',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in English',
    institution: 'Karpagam Academy of Higher Education',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1uHw58tzk5L3sZJLbCvZKHN791oPymuFI/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/027',
    name: 'Ms. M. Vaishali',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Research Scholar in English (Ph.D)',
    institution: 'Sri Ramakrishna College of Arts & Science',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/16vBaBirU45-iatyIoT3_0ZH_y_u00aOB/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/028',
    name: 'Ms. S. Vaishnavi Shri',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Student Member (Department of English)',
    institution: 'Sri Ramakrishna College of Arts & Science',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1li2uyNsKD24t4NllO5Ya6pasluv8P-OF/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/029',
    name: 'Dr. A. Sathiyavathi, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in English',
    institution: 'Karpagam Academy of Higher Education (Deemed to be University)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1zgkQvrWac41Isfj47oujxsBzQhD5y0kJ/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/030',
    name: 'Mr. A. Karthick',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in English',
    institution: 'Kangeyam Institute of Commerce - EBET Knowledge Park',
    location: 'Nathakadaiyur, Kangayam, Tirupur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1QNX2tl2_xxSU8C6lHhEoS5PxVmzsOrE_/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/031',
    name: 'Dr. B. Mythili, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Science and Humanities',
    institution: 'Karpagam Academy of Higher Education (Deemed to be University)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 28, 2026',
    driveUrl: 'https://drive.google.com/file/d/1z-D4JG89_tXW45aQcj07LnYtE1vXndoF/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/032',
    name: 'Ms. R. Janani',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Department of Management Studies (MBA)',
    institution: 'Jai Shriram Engineering College (Autonomous)',
    location: 'Avinashipalayam, Tiruppur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1v0zwhmxn3W8vMBy82GBmuE3YzOKFhWo5/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/033',
    name: 'Ms. K. R. Sowmiya',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Graduate Teacher in English',
    institution: 'Government High School, Karugampalayam',
    location: 'Palladam, Tiruppur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1nu0ufcrGwPa7Iw5cy6izdcs0k6ScFxWp/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/034',
    name: 'Dr. K. Usha Savithri, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Department of English (Science and Humanities)',
    institution: 'Karpagam Academy of Higher Education (Deemed to be University)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1mVXtcigp9TexO1qwwa_lirk_X4iLsk-i/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/035',
    name: 'Dr. G. Pavithra, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor of English',
    institution: 'Karpagam Academy of Higher Education (Deemed to be University)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1a4hQyWnpEYOmbuMT5ogbx3-PwTE9euAd/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/036',
    name: 'Dr. J. Veneeswari, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in Department of Computer Science & Engineering',
    institution: 'SRM Institute of Science and Technology (SRMIST)',
    location: 'Kattankulathur, Chennai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1VJnC-1XELVyeBt9vKW1gsvHzHfekZPup/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/037',
    name: 'Ms. S. Karthika, M.Phil',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Research Scholar in English',
    institution: 'NGM College (Autonomous)',
    location: 'Pollachi, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1eaJmNNlPlgsVctSZVUM44J_vyPQ_kqxR/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/038',
    name: 'Ms. R. Sonaalee',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Research Scholar in English',
    institution: "Bharathi Women's College (Autonomous)",
    location: 'Chennai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1H44R4TPhYy07m_Wa2oomSCZu5s-Mnt4_/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/039',
    name: 'Dr. A. Malika Begum, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor of English',
    institution: 'Madurai Kamaraj University College',
    location: 'Madurai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1O3VSYISbOGcCoPphkxT-x2PZRUpSLnUC/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/040',
    name: 'Dr. A. Anjana, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor of English',
    institution: 'PSG College of Arts & Science (Autonomous)',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1fEHoblDilNUUSmvuLL8i7aVF3kPc1NRK/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/041',
    name: 'Ms. Jenifer R',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Research Scholar in Electronics & Communication Engineering',
    institution: 'Vellore Institute of Technology (VIT)',
    location: 'Vellore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 29, 2026',
    driveUrl: 'https://drive.google.com/file/d/1_vhcN05q1hp1NS9pO4mRMG4JVR3Qr3Ww/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/042',
    name: 'Mr. K. Maheshwaran',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in English',
    institution: 'Selvamm Arts & Science College (SASC)',
    location: 'Thuraiyur, Trichy, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1uXBHK568IXeVOPln5YEW4LV1cu43bJ1-/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/043',
    name: 'Dr. K. Babu, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in Computer Science & Engineering',
    institution: 'SRM Institute of Science & Technology',
    location: 'Koliyanur Post, Villupuram, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1Sx_n90JcvxzB17B3S4JqZjFbdWCmAjPt/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/044',
    name: 'Dr. A. Nagamani Prabu, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Associate Professor in Physics',
    institution: 'Karpagam Academy of Higher Education',
    location: 'Pollachi / Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1kvkdxGDwNwYzEgKCaDa91MtVbZoRjHRV/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/045',
    name: 'Dr. K. Muthulakshmi, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Associate Professor in Electronics & Communication Engineering',
    institution: 'S. Veerasamy Chettiar College of Engineering and Technology (SVCET)',
    location: 'Vasudevanallur, Tenkasi, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1QlZbK2nOHFzMrcaOp3pT8utRVfHBXipd/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/046',
    name: 'Mr. S. Nagarajan',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Artificial Intelligence & Machine Learning',
    institution: 'SRM Institute of Science and Technology',
    location: 'Kattankulathur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1fo1oGQM5EN5VBDGVqbpJOMb3yzW8W2Ms/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/047',
    name: 'Ms. L. Kanimozhi',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Management Studies (MBA)',
    institution: 'Jai Shriram Engineering College',
    location: 'Tirupur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1lBVQ4zZkvysi_TRMJQTRZ7alWH3vWZZT/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/048',
    name: 'Ms. G. Hemaladevi',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Research Scholar in Computer Science & Engineering',
    institution: 'SRM Institute of Science and Technology',
    location: 'Kattankulathur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1wl-XKvOieTwM7lRf9geI5Gf-cjOx4Nwi/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/049',
    name: 'Dr. N. A. S. Vinoth, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Computer Science & Engineering',
    institution: 'SRM Institute of Science and Technology',
    location: 'Kattankulathur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 30, 2026',
    driveUrl: 'https://drive.google.com/file/d/1ECHNMkif1VD675GsxF-rnxzP4R7tkLW7/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/050',
    name: 'Dr. Kalpana C, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in Artificial Intelligence & Machine Learning',
    institution: 'SRM Institute of Science and Technology',
    location: 'Kattankulathur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 31, 2026',
    driveUrl: 'https://drive.google.com/file/d/1bpXnfqMjyQGUVT82CAuXqV4_0C_W7LJe/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/051',
    name: 'Dr. S. Delsi Robinsha, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in Computer Science & Engineering',
    institution: 'SRM Institute of Science and Technology',
    location: 'Kattankulathur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 31, 2026',
    driveUrl: 'https://drive.google.com/file/d/11ZF85ypsoW6jIOgOOGLjuQIrIBQAByeD/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/052',
    name: 'Ms. Tanusya',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Postgraduate Scholar in Artificial Intelligence & Data Science',
    institution: 'Sri Ranganathar Institute of Engineering and Technology',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'October 31, 2026',
    driveUrl: 'https://drive.google.com/file/d/1NwjcbZ0GoNGRlz5Lgd0DKFK4p_uTHTLv/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/053',
    name: 'Prof. B. Indrajith',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in English',
    institution: 'RVS College of Arts and Science',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 1, 2026',
    driveUrl: 'https://drive.google.com/file/d/1BwoVfNDZVDHlU-eRNBvTOW_efr8GwSeZ/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/054',
    name: 'Prof. Julia P',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor in Computer Science & Engineering',
    institution: 'Christ The King Engineering College',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 1, 2026',
    driveUrl: 'https://drive.google.com/file/d/1CA3J7iGDw2mnEciAMwIyO-n78OlXzvjc/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/055',
    name: 'Dr. Aparna Ramesh, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Faculty & Research Scholar in English',
    institution: 'Sri Ramakrishna College of Arts and Science',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 2, 2026',
    driveUrl: 'https://drive.google.com/file/d/1Rql0o1J5iMbFeGsV7q0WfZhmix7wvdnE/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/056',
    name: 'Dr. A. Bala Vanitha, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Faculty & Research Scholar in Electrical & Electronics Engineering',
    institution: 'Sri Sai Ram Engineering College',
    location: 'Chennai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 2, 2026',
    driveUrl: 'https://drive.google.com/file/d/19hTL7dMVJ8MUMGZkCdfpckXzwWShjMRm/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/057',
    name: 'Dr. M. Hamsalatha, Ph.D',
    role: 'Academic Council Member',
    council: 'Academic Council',
    designation: 'Assistant Professor in Science & Humanities',
    institution: 'Sri Ramakrishna Engineering College',
    location: 'Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 2, 2026',
    driveUrl: 'https://drive.google.com/file/d/1blVxv_nrj_H4WmbmijhFsvElxACtLcz2/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/058',
    name: 'Dr. R. Bathridevanath, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Faculty & Research Scholar in English',
    institution: 'ERTDU-RICE-MMS',
    location: 'Hosur, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 2, 2026',
    driveUrl: 'https://drive.google.com/file/d/1Q_bMQ0R5EzWWtNm6t3VRfGVOJkHLzgbe/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/059',
    name: 'A. Lincy Annet',
    role: 'Annual Member',
    council: 'Membership Council',
    designation: 'Research Scholar in ECE (AI & ML)',
    institution: 'Vellore Institute of Technology (VIT)',
    location: 'Vellore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 3, 2026',
    driveUrl: 'https://drive.google.com/file/d/1zeMHVMofmGT5pDwvo_0mBA2i7IDorgJT/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/060',
    name: 'Dr. L. Sugirtha, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor of Commerce',
    institution: 'Nadar Mahajana Sangam S. Vellaichamy Nadar College',
    location: 'Nagamalai, Madurai, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 4, 2026',
    driveUrl: 'https://drive.google.com/file/d/1XUgntXTP1hwXjT2wMVCO0uhqzvhEhMWn/view?usp=sharing'
  },
  {
    refId: 'ANRD/AB/2026/061',
    name: 'Dr. M. Vasanthamullai, Ph.D',
    role: 'Advisory Board Member',
    council: 'Advisory Board',
    designation: 'Assistant Professor of English',
    institution: 'Arignar Anna Govt Arts College',
    location: 'Vadachennimalai, Attur, Salem, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 4, 2026',
    driveUrl: 'https://drive.google.com/file/d/1L_IFFE4mgd0_lEsSExSwwggdTASUEew-/view?usp=sharing'
  },
  {
    refId: 'ANRD/AM/2026/062',
    name: 'Prof. J. Farida, M.Phil',
    role: 'Annual Member',
    council: 'Membership Council',
    designation: 'Assistant Professor of English',
    institution: 'RVS College of Arts and Science',
    location: 'Sulur, Coimbatore, Tamil Nadu',
    tenure: '2026 – 2036 (10-Year Tenure)',
    signatory: 'Dr. S. Sabitha Shunmugapriya, Chairman & Founder',
    status: 'ACTIVE & VERIFIED',
    regDate: 'November 4, 2026',
    driveUrl: 'https://drive.google.com/file/d/14xPWejAK9ONWfQPu8q7KDkqQMIzo8cwB/view?usp=sharing'
  }
];


const MemberAvatar = ({ name, refId, size = 80 }) => {
  const [imgError, setImgError] = useState(false);
  const cleanRef = refId ? refId.replace(/\//g, '_') : '';
  const photoPath = `/images/faculty/${cleanRef}.jpg?v=20261031_2`;

  useEffect(() => {
    setImgError(false);
  }, [refId]);

  if (!imgError && cleanRef) {
    return (
      <img
        src={photoPath}
        alt={name}
        onError={() => setImgError(true)}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: '50%',
          objectFit: 'cover',
          border: '2.5px solid #10b981',
          boxShadow: '0 4px 12px rgba(4, 120, 87, 0.2)',
          flexShrink: 0
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: '50%',
        background: '#f0fdf4',
        border: '2px solid #a7f3d0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }}
    >
      <Award size={Math.round(size * 0.55)} color="#059669" />
    </div>
  );
};

const VerifyCertificate = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const initialQuery = queryParams.get('id') || '';

  const [searchQuery, setSearchQuery] = useState(initialQuery);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [activeRollTab, setActiveRollTab] = useState('race'); // 'race' or 'roll'
  const [copiedInvite, setCopiedInvite] = useState(false);
  const [pointsRefresh, setPointsRefresh] = useState(0);

  useEffect(() => {
    const handlePointsUpdate = () => setPointsRefresh(prev => prev + 1);
    window.addEventListener('arivunest-points-updated', handlePointsUpdate);
    return () => window.removeEventListener('arivunest-points-updated', handlePointsUpdate);
  }, []);

  const handleCopyReferral = (member) => {
    if (!member) return;
    const shareText = `🎓 *Arivu Nest – Advisory & Academic Council Nomination*\n\n` +
      `Nominate yourself or join under Member *${member.name}* (Ref ID: *${member.refId}*).\n` +
      `🏛️ Lifetime Institutional Membership Fee: *₹100* (Special Introductory Offer)\n\n` +
      `🔗 Official Google Form: https://forms.gle/UfkUncKELYenUJE46\n` +
      `✅ Enter Ref ID *${member.refId}* in the form to support this member for Committee Leadership!`;
    navigator.clipboard.writeText(shareText);
    setCopiedInvite(true);
    setTimeout(() => setCopiedInvite(false), 3000);
  };

  const handleSearch = (query) => {
    const q = (query || searchQuery).trim().toLowerCase();
    setHasSearched(true);
    if (!q) {
      setSelectedRecord(null);
      return;
    }

    const match = VERIFIED_MEMBERS.find((m) =>
      m.refId.toLowerCase().includes(q) ||
      m.name.toLowerCase().includes(q) ||
      m.institution.toLowerCase().includes(q)
    );

    setSelectedRecord(match || null);
  };

  useEffect(() => {
    if (initialQuery) {
      handleSearch(initialQuery);
    }
  }, [initialQuery]);

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        {/* Header */}
        <header style={styles.header}>
          <div style={styles.badge}>
            <ShieldCheck size={16} />
            <span>OFFICIAL CREDENTIAL VERIFICATION SYSTEM</span>
          </div>
          <h1 style={styles.title}>Institutional Certificate & Member Verification</h1>
          <p style={styles.subtitle}>
            Verify 10-year official appointments for the Advisory Board and Academic Council under{' '}
            <strong>Arivu Nest – Research and Development</strong>, a Unit of Jjegan Graphers (MSME Reg:{' '}
            <code>UDYAM-TN-32-0048110</code>).
          </p>
        </header>

        {/* Search Bar */}
        <div style={styles.searchBox}>
          <div style={styles.inputWrapper}>
            <Search size={20} color="#64748b" style={{ marginLeft: '12px' }} />
            <input
              type="text"
              placeholder="Enter Reference ID (e.g. ANRD/AB/2026/018) or Professor Name..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSearch(searchQuery)}
              style={styles.searchInput}
            />
            <button onClick={() => handleSearch(searchQuery)} style={styles.searchBtn}>
              Verify Credential
            </button>
          </div>

          {/* Quick Filter Chips */}
          <div style={styles.chipRow}>
            <span style={{ fontSize: '12px', color: '#64748b', fontWeight: '600' }}>Quick Inspect:</span>
            {['ANRD/AB/2026/021', 'ANRD/AB/2026/022', 'ANRD/AM/2026/008', 'ANRD/AB/2026/002'].map((id) => (
              <button
                key={id}
                onClick={() => {
                  setSearchQuery(id);
                  handleSearch(id);
                }}
                style={styles.chip}
              >
                {id}
              </button>
            ))}
          </div>
        </div>

        {/* Verification Results */}
        {selectedRecord ? (
          <div style={styles.certificateCard}>
            <div style={styles.cardHeader}>
              <div style={styles.statusPill}>
                <CheckCircle2 size={18} color="#10b981" />
                <span>{selectedRecord.status}</span>
              </div>
              <div style={styles.refBadge}>{selectedRecord.refId}</div>
            </div>

            <div style={styles.cardBody}>
              <MemberAvatar name={selectedRecord.name} refId={selectedRecord.refId} size={84} />

              <div style={styles.mainInfo}>
                <h2 style={styles.memberName}>{selectedRecord.name}</h2>
                <div style={styles.memberRole}>{selectedRecord.role}</div>
                <div style={styles.memberDesignation}>{selectedRecord.designation}</div>
                <div style={styles.institutionRow}>
                  <Building size={16} color="#64748b" />
                  <span>{selectedRecord.institution} • {selectedRecord.location}</span>
                </div>
              </div>
            </div>

            <div style={styles.cardGrid}>
              <div style={styles.gridItem}>
                <span style={styles.gridLabel}>Designated Body</span>
                <span style={styles.gridValue}>{selectedRecord.council}</span>
              </div>
              <div style={styles.gridItem}>
                <span style={styles.gridLabel}>Appointed Tenure</span>
                <span style={{ ...styles.gridValue, color: '#059669' }}>{selectedRecord.tenure}</span>
              </div>
              <div style={styles.gridItem}>
                <span style={styles.gridLabel}>Sole Signatory</span>
                <span style={styles.gridValue}>{selectedRecord.signatory}</span>
              </div>
              <div style={styles.gridItem}>
                <span style={styles.gridLabel}>Accrediting Body</span>
                <span style={styles.gridValue}>Ministry of MSME, Govt. of India (UDYAM-TN-32-0048110)</span>
              </div>
            </div>

            {selectedRecord.driveUrl && (
              <div style={{ marginTop: '22px', marginBottom: '18px' }}>
                <a
                  href={selectedRecord.driveUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={styles.downloadCertBtn}
                >
                  <Download size={18} />
                  <span>View & Download Original Certificate (Official Signed PDF)</span>
                  <ExternalLink size={15} style={{ opacity: 0.85 }} />
                </a>
              </div>
            )}

            {/* Dr. Sabitha Mam's Referral Points & Committee Standing Card */}
            {(() => {
              const pts = getPointsForMember(selectedRecord.refId);
              const rankedAll = getRankedMembers(VERIFIED_MEMBERS);
              const memberRankItem = rankedAll.find(r => r.refId === selectedRecord.refId) || { rank: 10, roleDesignation: getRoleForRank(10) };
              const whatsAppUrl = getWhatsAppShareUrl(selectedRecord);

              return (
                <div style={styles.referralBox}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '14px', marginBottom: '14px' }}>
                    <div>
                      <div style={{ fontSize: '11px', textTransform: 'uppercase', letterSpacing: '1px', fontWeight: '800', color: '#047857', marginBottom: '4px', display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <Trophy size={14} color="#059669" />
                        <span>Committee Leadership Standing (Dr. Sabitha Mam's Initiative)</span>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                        <span style={styles.pointsPill}>⭐ {pts} Verified Referral Points</span>
                        <span style={{ ...styles.rankBadge, background: memberRankItem.roleDesignation.bg, color: memberRankItem.roleDesignation.color, border: `1px solid ${memberRankItem.roleDesignation.color}30` }}>
                          {memberRankItem.roleDesignation.badge}
                        </span>
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                      <a
                        href={whatsAppUrl}
                        target="_blank"
                        rel="noreferrer"
                        style={styles.whatsAppShareBtn}
                        title="Share your referral link on WhatsApp to get new ₹100 registrations"
                      >
                        <Share2 size={15} />
                        <span>Share on WhatsApp (+10 Pts)</span>
                      </a>
                      <button
                        onClick={() => handleCopyReferral(selectedRecord)}
                        style={styles.copyInviteBtn}
                        title="Copy pre-filled nomination invite text"
                      >
                        {copiedInvite ? <Check size={14} color="#047857" /> : <Copy size={14} />}
                        <span>{copiedInvite ? 'Copied to Clipboard!' : 'Copy Invite'}</span>
                      </button>
                    </div>
                  </div>
                  <div style={styles.referralNotice}>
                    💡 <strong>How it works:</strong> Every colleague or student who registers on the Google Form (<strong>₹100</strong> lifetime fee) using your Reference ID <code>{selectedRecord.refId}</code> credits <strong>+10 Points</strong> to your tally. The highest point-earners will be formally appointed as <strong>President</strong>, <strong>Vice President</strong>, <strong>Secretary</strong>, and <strong>Joint Secretary</strong> of the Arivu Nest Advisory Committee!
                  </div>
                </div>
              );
            })()}

            <div style={styles.cardFooter}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <img src="/images/logos/arivu-nest-logo.png" alt="Arivu Nest" style={{ height: '32px' }} />
                <img src="/images/logos/msme-logo.png" alt="MSME" style={{ height: '24px' }} />
                <img src="/images/logos/jjegan-logo.png" alt="Jjegan Graphers" style={{ height: '28px' }} />
              </div>
              <div style={{ fontSize: '12px', color: '#64748b', textAlign: 'right' }}>
                Official Digital Verification Record &bull; Arivu Nest R&D
              </div>
            </div>
          </div>
        ) : hasSearched ? (
          <div style={styles.notFoundBox}>
            <h3>No Record Found</h3>
            <p>
              No verified certificate matched &quot;<strong>{searchQuery}</strong>&quot;. Please verify the Reference ID
              format (e.g. <code>ANRD/AB/2026/001</code>) or contact{' '}
              <a href="https://mail.google.com/mail/?view=cm&fs=1&to=nandhakumar@arivunest.com&su=Certificate%20Verification%20Assistance" target="_blank" rel="noopener noreferrer">nandhakumar@arivunest.com</a>.
            </p>
          </div>
        ) : (
          <div style={styles.introBox}>
            <div style={{ fontSize: '40px', marginBottom: '14px' }}>📜</div>
            <h3 style={{ margin: '0 0 8px 0', fontSize: '18px', color: '#0f172a' }}>
              Public Credential Verification
            </h3>
            <p style={{ margin: 0, color: '#64748b', fontSize: '14px', maxWidth: '600px', lineHeight: '1.6' }}>
              Enter any official Reference ID from your appointment order or certificate to view its real-time
              institutional validity, tenure period, and accreditation credentials.
            </p>
          </div>
        )}

                {/* Directory & Leadership Race Section */}
        <section style={{ marginTop: '60px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginBottom: '20px' }}>
            <div>
              <h3 style={{ fontSize: '22px', fontWeight: '800', color: '#0f172a', margin: '0 0 6px' }}>
                🏛️ Advisory Board & Academic Governance
              </h3>
              <p style={{ margin: 0, color: '#64748b', fontSize: '14px' }}>
                Track the 2026 Committee Leadership Points Race or verify inducted members roll
              </p>
            </div>
            
            {/* View Switcher Tabs */}
            <div style={styles.tabToggleRow}>
              <button
                onClick={() => setActiveRollTab('race')}
                style={activeRollTab === 'race' ? styles.tabToggleActive : styles.tabToggle}
              >
                🏆 Committee Leadership Race (Points)
              </button>
              <button
                onClick={() => setActiveRollTab('roll')}
                style={activeRollTab === 'roll' ? styles.tabToggleActive : styles.tabToggle}
              >
                📜 Member Roll Directory ({VERIFIED_MEMBERS.length})
              </button>
            </div>
          </div>
          {activeRollTab === 'race' ? (
            /* Tab 1: Live Committee Leadership Race */
            <div style={styles.tableWrapper}>
              <div style={styles.raceHeaderBanner}>
                <div>
                  <strong style={{ fontSize: '15px', color: '#065f46', display: 'block' }}>
                    🔥 2026 Advisory Committee Leadership Race (Dr. Sabitha Mam's Initiative)
                  </strong>
                  <span style={{ fontSize: '12.5px', color: '#047857' }}>
                    Every referral registration (₹100 fee) using a member's Reference ID earns +10 Points toward President / Vice President appointment.
                  </span>
                </div>
                <a
                  href="https://forms.gle/UfkUncKELYenUJE46"
                  target="_blank"
                  rel="noreferrer"
                  style={styles.registerFormBtn}
                >
                  ✍️ Apply / Register (₹100) &rarr;
                </a>
              </div>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.thRow}>
                    <th style={{ ...styles.th, width: '70px', textAlign: 'center' }}>Rank</th>
                    <th style={styles.th}>Member & Reference ID</th>
                    <th style={styles.th}>Target Leadership Role</th>
                    <th style={styles.th}>College / Institution</th>
                    <th style={{ ...styles.th, textAlign: 'center' }}>Referral Points</th>
                    <th style={styles.th}>Fast Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {getRankedMembers(VERIFIED_MEMBERS).map((m) => {
                    const whatsAppUrl = getWhatsAppShareUrl(m);
                    return (
                      <tr key={m.refId} style={{ ...styles.tr, background: m.rank === 1 ? '#f0fdf4' : m.rank <= 3 ? '#faf5ff' : '#ffffff' }}>
                        <td style={{ ...styles.td, textAlign: 'center' }}>
                          <span style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '32px',
                            height: '32px',
                            borderRadius: '50%',
                            background: m.rank === 1 ? '#fef08a' : m.rank === 2 ? '#e2e8f0' : m.rank === 3 ? '#ffedd5' : '#f1f5f9',
                            fontWeight: '800',
                            fontSize: '13px',
                            color: '#0f172a'
                          }}>
                            {m.rank === 1 ? '👑' : m.rank === 2 ? '🥈' : m.rank === 3 ? '🥉' : `#${m.rank}`}
                          </span>
                        </td>
                        <td style={styles.td}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <MemberAvatar name={m.name} refId={m.refId} size={40} />
                            <div>
                              <div style={{ fontWeight: '700', color: '#0f172a', fontSize: '14px' }}>{m.name}</div>
                              <span style={{ fontFamily: 'monospace', fontSize: '11.5px', color: '#059669', fontWeight: '700' }}>{m.refId}</span>
                            </div>
                          </div>
                        </td>
                        <td style={styles.td}>
                          <span style={{
                            background: m.roleDesignation.bg,
                            color: m.roleDesignation.color,
                            padding: '4px 9px',
                            borderRadius: '6px',
                            fontSize: '11.5px',
                            fontWeight: '700',
                            display: 'inline-block'
                          }}>
                            {m.roleDesignation.title}
                          </span>
                        </td>
                        <td style={{ ...styles.td, color: '#475569', fontSize: '12.5px' }}>{m.institution}</td>
                        <td style={{ ...styles.td, textAlign: 'center' }}>
                          <span style={{
                            background: '#ecfdf5',
                            color: '#047857',
                            padding: '4px 10px',
                            borderRadius: '999px',
                            fontWeight: '800',
                            fontSize: '13px'
                          }}>
                            ⭐ {m.referralPoints} pts
                          </span>
                        </td>
                        <td style={{ ...styles.td, whiteSpace: 'nowrap' }}>
                          <div style={{ display: 'flex', gap: '6px', alignItems: 'center' }}>
                            <a
                              href={whatsAppUrl}
                              target="_blank"
                              rel="noreferrer"
                              style={styles.miniWhatsAppBtn}
                              title="Share on WhatsApp to earn points for this member"
                            >
                              <span>📲 Share</span>
                            </a>
                            <a
                              href="https://forms.gle/UfkUncKELYenUJE46"
                              target="_blank"
                              rel="noreferrer"
                              style={styles.miniSupportBtn}
                              title="Register ₹100 on Google Form entering this Reference ID"
                            >
                              <span>Support</span>
                            </a>
                            <button
                              onClick={() => {
                                setSearchQuery(m.refId);
                                handleSearch(m.refId);
                                window.scrollTo({ top: 180, behavior: 'smooth' });
                              }}
                              style={styles.inspectBtn}
                              title="Inspect official certificate record"
                            >
                              Verify &rarr;
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            /* Tab 2: Standard Member Directory */
            <div style={styles.tableWrapper}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.thRow}>
                    <th style={styles.th}>Reference ID</th>
                    <th style={styles.th}>Member Name</th>
                    <th style={styles.th}>Designated Wing</th>
                    <th style={styles.th}>Institution</th>
                    <th style={styles.th}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {VERIFIED_MEMBERS.map((m) => (
                    <tr key={m.refId} style={styles.tr}>
                      <td style={{ ...styles.td, fontFamily: 'monospace', fontWeight: '700', color: '#059669' }}>
                        {m.refId}
                      </td>
                      <td style={{ ...styles.td, fontWeight: '700', color: '#0f172a' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <MemberAvatar name={m.name} refId={m.refId} size={36} />
                          <span>{m.name}</span>
                        </div>
                      </td>
                      <td style={styles.td}>
                        <span
                          style={{
                            background: m.council === 'Advisory Board' ? '#ecfdf5' : '#eff6ff',
                            color: m.council === 'Advisory Board' ? '#047857' : '#1d4ed8',
                            padding: '3px 8px',
                            borderRadius: '6px',
                            fontSize: '11.5px',
                            fontWeight: '700'
                          }}
                        >
                          {m.council}
                        </span>
                      </td>
                      <td style={{ ...styles.td, color: '#475569', fontSize: '13px' }}>{m.institution}</td>
                      <td style={{ ...styles.td, whiteSpace: 'nowrap' }}>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          <button
                            onClick={() => {
                              setSearchQuery(m.refId);
                              handleSearch(m.refId);
                              window.scrollTo({ top: 180, behavior: 'smooth' });
                            }}
                            style={styles.inspectBtn}
                          >
                            Verify &rarr;
                          </button>
                          {m.driveUrl && (
                            <a
                              href={m.driveUrl}
                              target="_blank"
                              rel="noreferrer"
                              style={styles.pdfTableBtn}
                              title="View & Download Official PDF Certificate"
                            >
                              <FileText size={13} />
                              <span>PDF</span>
                              <ExternalLink size={11} />
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
  );
};

const styles = {
  page: { background: '#f8fafc', minHeight: '100vh', padding: 'clamp(40px, 6vw, 70px) 16px', fontFamily: "'Inter', sans-serif" },
  container: { maxWidth: '1050px', margin: '0 auto' },
  header: { textAlign: 'center', marginBottom: '40px' },
  badge: { display: 'inline-flex', alignItems: 'center', gap: '8px', background: '#ecfdf5', color: '#047857', border: '1px solid #a7f3d0', padding: '6px 16px', borderRadius: '999px', fontSize: '11px', fontWeight: '800', letterSpacing: '1px', textTransform: 'uppercase', marginBottom: '14px' },
  title: { fontSize: 'clamp(26px, 5vw, 36px)', color: '#0f172a', fontWeight: '800', margin: '0 0 10px 0', letterSpacing: '-0.5px' },
  subtitle: { fontSize: '15px', color: '#64748b', maxWidth: '750px', margin: '0 auto', lineHeight: '1.6' },
  searchBox: { background: '#ffffff', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1.5px solid #e2e8f0', marginBottom: '36px' },
  inputWrapper: { display: 'flex', alignItems: 'center', background: '#f8fafc', border: '1.5px solid #cbd5e1', borderRadius: '12px', padding: '4px', gap: '8px' },
  searchInput: { flex: 1, border: 'none', background: 'transparent', padding: '12px 14px', fontSize: '15px', outline: 'none', fontFamily: 'inherit' },
  searchBtn: { background: '#059669', color: '#ffffff', border: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: '700', fontSize: '14px', cursor: 'pointer', whiteSpace: 'nowrap', boxShadow: '0 4px 12px rgba(5, 150, 105, 0.25)' },
  chipRow: { display: 'flex', alignItems: 'center', gap: '10px', marginTop: '16px', flexWrap: 'wrap' },
  chip: { background: '#f1f5f9', border: '1px solid #cbd5e1', padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontFamily: 'monospace', fontWeight: '600', color: '#334155', cursor: 'pointer' },
  certificateCard: { background: '#ffffff', border: '2px solid #10b981', borderRadius: '18px', padding: '36px', boxShadow: '0 10px 30px rgba(16, 185, 129, 0.12)' },
  cardHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1.5px solid #f1f5f9', paddingBottom: '18px', marginBottom: '24px', flexWrap: 'wrap', gap: '12px' },
  statusPill: { display: 'inline-flex', alignItems: 'center', gap: '6px', background: '#ecfdf5', color: '#047857', padding: '6px 14px', borderRadius: '999px', fontSize: '12px', fontWeight: '800', letterSpacing: '0.5px' },
  refBadge: { fontFamily: 'monospace', fontSize: '16px', fontWeight: '800', color: '#0f172a', background: '#f1f5f9', padding: '6px 14px', borderRadius: '8px' },
  cardBody: { display: 'flex', alignItems: 'center', gap: '24px', marginBottom: '28px', flexWrap: 'wrap' },
  memberAvatar: { width: '80px', height: '80px', borderRadius: '50%', background: '#f0fdf4', border: '2px solid #a7f3d0', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  mainInfo: { flex: 1 },
  memberName: { margin: '0 0 6px 0', fontSize: '24px', fontWeight: '800', color: '#0f172a' },
  memberRole: { fontSize: '15px', color: '#059669', fontWeight: '700', marginBottom: '4px' },
  memberDesignation: { fontSize: '14px', color: '#334155', marginBottom: '6px' },
  institutionRow: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13.5px', color: '#64748b' },
  cardGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', background: '#f8fafc', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0', marginBottom: '24px' },
  gridItem: { display: 'flex', flexDirection: 'column', gap: '4px' },
  gridLabel: { fontSize: '11px', textTransform: 'uppercase', color: '#64748b', fontWeight: '700' },
  gridValue: { fontSize: '13.5px', color: '#0f172a', fontWeight: '600' },
  cardFooter: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderTop: '1.5px solid #f1f5f9', paddingTop: '18px', flexWrap: 'wrap', gap: '12px' },
  notFoundBox: { background: '#fff', border: '1.5px solid #fecdd3', borderRadius: '14px', padding: '36px', textAlign: 'center', color: '#be123c' },
  introBox: { background: '#ffffff', border: '1.5px dashed #cbd5e1', borderRadius: '14px', padding: '48px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  tableWrapper: { background: '#ffffff', border: '1.5px solid #e2e8f0', borderRadius: '14px', overflowX: 'auto', boxShadow: '0 2px 10px rgba(0,0,0,0.03)' },
  table: { width: '100%', borderCollapse: 'collapse', textAlign: 'left' },
  thRow: { background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0' },
  th: { padding: '14px 16px', fontSize: '12px', fontWeight: '700', color: '#475569', textTransform: 'uppercase' },
  tr: { borderBottom: '1px solid #f1f5f9' },
  td: { padding: '14px 16px', fontSize: '13.5px' },
  inspectBtn: { background: '#f0fdf4', color: '#059669', border: '1px solid #a7f3d0', padding: '5px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: '700', cursor: 'pointer' },
  pdfTableBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    background: '#ecfdf5',
    color: '#047857',
    border: '1px solid #a7f3d0',
    padding: '5px 9px',
    borderRadius: '6px',
    fontSize: '11.5px',
    fontWeight: '700',
    textDecoration: 'none',
  },
  referralBox: {
    background: 'linear-gradient(135deg, #f0fdf4 0%, #ecfdf5 100%)',
    border: '1.5px solid #a7f3d0',
    borderRadius: '14px',
    padding: '20px',
    marginTop: '20px',
    marginBottom: '24px',
  },
  pointsPill: {
    display: 'inline-flex',
    alignItems: 'center',
    background: '#047857',
    color: '#ffffff',
    padding: '5px 12px',
    borderRadius: '999px',
    fontWeight: '800',
    fontSize: '13px',
    letterSpacing: '0.3px',
  },
  rankBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '5px 12px',
    borderRadius: '8px',
    fontWeight: '700',
    fontSize: '12px',
  },
  whatsAppShareBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    background: '#25D366',
    color: '#ffffff',
    textDecoration: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '700',
    fontSize: '12.5px',
    boxShadow: '0 2px 8px rgba(37, 211, 102, 0.3)',
  },
  copyInviteBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    background: '#ffffff',
    color: '#0f172a',
    border: '1px solid #cbd5e1',
    padding: '8px 14px',
    borderRadius: '8px',
    fontWeight: '700',
    fontSize: '12.5px',
    cursor: 'pointer',
  },
  referralNotice: {
    marginTop: '12px',
    color: '#166534',
    fontSize: '12.5px',
    lineHeight: '1.6',
    borderTop: '1px solid #bbf7d0',
    paddingTop: '10px',
  },
  tabToggleRow: {
    display: 'flex',
    gap: '8px',
    background: '#f1f5f9',
    padding: '4px',
    borderRadius: '10px',
  },
  tabToggle: {
    background: 'transparent',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    color: '#64748b',
    cursor: 'pointer',
  },
  tabToggleActive: {
    background: '#ffffff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '800',
    color: '#047857',
    boxShadow: '0 2px 6px rgba(0,0,0,0.06)',
    cursor: 'pointer',
  },
  raceHeaderBanner: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
    borderBottom: '1.5px solid #a7f3d0',
    padding: '16px 20px',
    flexWrap: 'wrap',
    gap: '12px',
  },
  registerFormBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    background: '#047857',
    color: '#ffffff',
    textDecoration: 'none',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '700',
    fontSize: '12.5px',
    boxShadow: '0 2px 8px rgba(4, 120, 87, 0.25)',
  },
  miniWhatsAppBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '3px',
    background: '#25D366',
    color: '#ffffff',
    textDecoration: 'none',
    padding: '4px 8px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: '700',
  },
  miniSupportBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '3px',
    background: '#047857',
    color: '#ffffff',
    textDecoration: 'none',
    padding: '4px 8px',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: '700',
  }
};

export default VerifyCertificate;
